
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/AuthEmbedded",
      function () {
        return require("private-next-pages/AuthEmbedded.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/AuthEmbedded"])
      });
    }
  